import './MDLImpressum.scss'

function MDLImpressum() {
  return (<div id="mdl-impressum">
    <h2>Impressum</h2>
    <div>Verein Mission der Liebe e.V.</div>
    <div>Herrenstraße 39</div>
    <div>93354 Siegenburg</div>
    <br />
    <div>Vertreten durch</div>
    <div>1. Vorsitzende: Intan Akbulut</div>
    <div>2. Vorsitzender: Erhan Akbulut</div>
    <br />
    <div>Registereintrag:</div>
    <div>Eintragung im Vereinsregister</div>
    <div>Registergericht: Amtsgericht Amberg</div>
    <div>Registernummer: VR 200803</div>
    <br />
    <div id="impressum-separator"></div>
    <br />
    <div>E-Mail:</div>
    <div>info@missionderliebe.com</div>
    {/* <div>Musterstraße 12</div>
    <div>12345 Musterort</div> */}
  </div>)
}

export default MDLImpressum